export default __webpack_public_path__ + "static/media/home-vertical-portfolio-img-02.2726d0d0.jpg";